'use client';

import { Checkbox, FormControlLabel, FormControlProps } from '@mui/material';

import { styled } from '../../styles';

export const CheckboxFormControlLabel = styled(
  FormControlLabel,
)<FormControlProps>(({ disabled, theme }) => ({
  color: disabled ? theme.palette.text3 : theme.palette.text1,
  margin: 0,
}));

export const MuiCheckbox = styled(Checkbox)(({ theme, size }) => ({
  padding: 0,
  marginRight: theme.spacing(2),

  '.MuiSvgIcon-root': {
    width: size === 'small' ? 20 : 24,
    height: size === 'small' ? 20 : 24,
  },
}));
